// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Inter var, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

/*
NOTE: Inter font:
- Defined in HTML template for easy toggling of static() path in trinity & prod (CDN).
- To save bandwidth, do not include variable italic form.
- Experimental version with oblique style for italic is too experimental.
- To save bandwidth, only latin characters are loaded (70KB vs 318KB).
- Font preload added to HTML template.
*/

/*
These overrides match bootstrap's reset since a lot of styling was developed
assumings its reset values.
*/
svg {
  display: inline;
}

a {
  --tw-text-opacity: 1;
  color: rgb(34 110 255 / var(--tw-text-opacity));
}

a:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(27 149 224 / var(--tw-text-opacity));
}

a:hover {
  text-decoration-line: underline;
}

p {
  margin-bottom: 1rem;
}

/*
QUICK FIX: Without this, <input> forces fieldset to expand beyond its parent
container. This, however, doesn't appear to be a common problem (when searching
for reasons for this) so it's unclear why 'auto' isn't the default.
*/
fieldset {
  min-inline-size: auto;
}

/* stylelint-disable custom-property-pattern, function-no-unknown */
.mdx-editor-container-dark {
  --accentText: #1b95e0 !important;
  --baseBg: #27272a !important; /* Equivalent to bg-highlight */
  --basePageBg: #202024 !important; /* Equivalent to bg-primary */
  --baseBgHover: #333 !important;
  --accentBorder: #5b75fe !important;
  --accentSolidHover: #5b75fe !important;
  --baseText: #e2e8f0 !important;
}

.mdx-editor-container-light {
  --accentBorder: #5b75fe !important;
  --accentSolidHover: #5b75fe !important;
  --accentText: #226eff !important;
  --baseBg: #e1e1e1 !important; /* Equivalent to bg-highlight */
  --basePageBg: #fefefe !important; /* Equivalent to bg-primary */
}
/* stylelint-enable custom-property-pattern, function-no-unknown */

.mdx-editor-content {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}

.mdx-editor-content:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}

.mdx-editor-content {
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.625rem;
}

.mdx-editor-content blockquote {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(225 225 225 / var(--tw-bg-opacity));
}

.mdx-editor-content blockquote:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}

.mdx-editor-content blockquote {
  margin-left: 2px;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 2rem;
  padding-right: 0.5rem;
  border-radius: 0.5rem;
  border-left-width: 4px;
  --tw-border-opacity: 1;
  border-left-color: rgb(33 37 41 / var(--tw-border-opacity));
}

.mdx-editor-content blockquote:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-left-color: rgb(226 232 240 / var(--tw-border-opacity));
}

.mdx-editor-content h1,
  .mdx-editor-content h2,
  .mdx-editor-content h3,
  .mdx-editor-content h4,
  .mdx-editor-content h5,
  .mdx-editor-content h6 {
  margin-top: 1rem;
}

.mdx-editor-content h1:first-child,
  .mdx-editor-content h2:first-child,
  .mdx-editor-content h3:first-child,
  .mdx-editor-content h4:first-child,
  .mdx-editor-content h5:first-child,
  .mdx-editor-content h6:first-child {
  margin-top: 0px;
}

.mdx-editor-content h1 {
  font-size: 1.3rem;
  font-weight: 700;
}

.mdx-editor-content h2 {
  font-size: 1.25rem;
  font-weight: 700;
}

.mdx-editor-content h3 {
  font-size: 1.2rem;
  font-weight: 700;
}

.mdx-editor-content h4 {
  font-size: 1.15rem;
  font-weight: 700;
}

.mdx-editor-content h5 {
  font-size: 1.10rem;
  font-weight: 600;
}

.mdx-editor-content h6 {
  font-size: 1.05rem;
  font-weight: 600;
}

.mdx-editor-content ol {
  list-style-position: outside;
  list-style-type: decimal;
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
}

.mdx-editor-content ul {
  list-style-position: outside;
  list-style-type: disc;
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
}

.mdx-editor-content li {
  margin-top: 0px;
  margin-bottom: 0px;
}

.mdx-editor-content li>ol {
  padding-left: 1.25rem;
}

.mdx-editor-content li>ul {
  padding-left: 1.25rem;
}

.mdx-editor-content p {
  margin-bottom: 0px;
}

.mdx-editor-content .cm-editor {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
  overflow-x: scroll;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
  padding: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1.25;
}

.tw-container {
  width: 100%;
}

@media (min-width: 640px) {

  .tw-container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {

  .tw-container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {

  .tw-container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {

  .tw-container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {

  .tw-container {
    max-width: 1536px;
  }
}

/*
   * Scrollbar
   * The primary goal is to customize the horizontal scrollbar for horizontal
   * feeds as the default is too ugly to bear.
  */

/*
    Firefox only

    Styles are disabled for chrome/webkit because if they're specified they
    take priority. See:

    https://syntackle.com/blog/changes-to-scrollbar-styling-in-chrome-121/

  */

@supports not selector(::-webkit-scrollbar) {
  .ff-scrollbar {
      scrollbar-color: #888 transparent;
      scrollbar-width: thin
  }
    }

::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

::-webkit-scrollbar-track {
    background: transparent;
  }

::-webkit-scrollbar-thumb {
    background: #888;
  }

.modal-scrollbar::-webkit-scrollbar {
    width: 10px;
  }

.modal-scrollbar::-webkit-scrollbar-thumb {
    background: #444;
  }

.modal-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #333;
  }

.tw-dark ::-webkit-scrollbar-thumb {
    background: #777;
  }

::-webkit-scrollbar-thumb:hover {
    background: #444;
  }

.tw-dark ::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }

/*
   * Other styles
   */

.tw-text-primary {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}

.tw-text-primary:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}

.tw-text-primary-inverted {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}

.tw-text-primary-inverted:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}

.tw-text-light {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
}

.tw-text-dark {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}

.tw-text-muted {
  --tw-text-opacity: 1;
  color: rgb(105 105 115 / var(--tw-text-opacity));
}

.tw-text-muted:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}

.tw-bg-custom-hover:hover {
    background-color: var(--hover-bg) !important;
  }

.tw-bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}

.tw-bg-primary:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 36 / var(--tw-bg-opacity));
}

.tw-bg-primary-inverted {
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 36 / var(--tw-bg-opacity));
}

.tw-bg-primary-inverted:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}

.tw-bg-highlight {
  --tw-bg-opacity: 1;
  background-color: rgb(225 225 225 / var(--tw-bg-opacity));
}

.tw-bg-highlight:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}

.tw-bg-highlight-inverted {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}

.tw-bg-highlight-inverted:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(225 225 225 / var(--tw-bg-opacity));
}

.tw-bg-striped-light {
    background-image: linear-gradient(
      45deg,
      #f5f5f5 25%,
      #f0f0f0 25%,
      #f0f0f0 50%,
      #f5f5f5 50%,
      #f5f5f5 75%,
      #f0f0f0 75%,
      #f0f0f0 100%
    );
    background-size: 56.57px 56.57px;
  }

.tw-bg-canvas {
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 240 / var(--tw-bg-opacity));
}

.tw-bg-canvas:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(19 19 19 / var(--tw-bg-opacity));
}

.tw-story-kbsel-outline {
    /* Marked !important to take precedence when tw-story-outline is applied
    due to a simultaneous hover on the story. */
    outline-style: solid;
    outline-width: 2px;
    outline-color: #5b75fe !important;
  }

@media (hover: hover) and (pointer: fine) {

  .tw-story-kbsel-outline:hover {
    outline-color: #5b75fe !important;
  }
}

.tw-story-kbsel-outline:is(.tw-dark *) {
  outline-color: #5b75fe !important;
}

@media (hover: hover) and (pointer: fine) {

  .tw-story-kbsel-outline:hover:is(.tw-dark *) {
    outline-color: #5b75fe !important;
  }
}

.tw-text-blue {
  --tw-text-opacity: 1;
  color: rgb(34 110 255 / var(--tw-text-opacity));
}

.tw-text-blue:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(27 149 224 / var(--tw-text-opacity));
}

.tw-link {
  --tw-text-opacity: 1;
  color: rgb(34 110 255 / var(--tw-text-opacity));
}

@media (hover: hover) and (pointer: fine) {

  .tw-link:hover {
    text-decoration-line: underline;
  }
}

.tw-link:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(27 149 224 / var(--tw-text-opacity));
}

.tw-youtube-container-portrait {
    height: max(min(80vh, 700px), 300px);
  }

/*
   * Legacy styling for keyboard highlight bars
   */

/* NA = keyboard selection is not applicable */

.kb-pad-4-na {
  border-width: 1px;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 4px;
  border-right-width: 0px;
  border-style: solid;
  border-left-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
}

.kb-pad-4 {
  border-width: 1px;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 4px;
  border-right-width: 0px;
  border-style: solid;
  border-left-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
}

.kb-pad-4.kb-sel {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(91 117 254 / var(--tw-border-opacity)) !important;
}

.kb-pad-4.kb-sel:is(.tw-dark *) {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(91 117 254 / var(--tw-border-opacity)) !important;
}

.kb-bar {
  border-width: 1px;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 3px;
  border-right-width: 0px;
  border-style: solid;
  border-left-color: transparent;
}

.kb-bar.kb-sel {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(91 117 254 / var(--tw-border-opacity)) !important;
}

.kb-bar.kb-sel:is(.tw-dark *) {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(91 117 254 / var(--tw-border-opacity)) !important;
}

/*
  * Select styling
  */

.tw-select-arrow {
    background-image: linear-gradient(45deg, transparent 50%, currentcolor 50%),
      linear-gradient(135deg, currentcolor 50%, transparent 50%);
    background-position:
      calc(100% - 20px) calc(1px + 50%),
      calc(100% - 16px) calc(1px + 50%);
    background-repeat: no-repeat;
    background-size:
      4px 4px,
      4px 4px;
  }

/*
  * animated linear fade out (for hover menu)
  */

.tw-fade-out-mask-right {
    padding: 2px; /* creates space for outline */
    margin: -2px; /* pulls it back to original position */
    -webkit-mask-image: linear-gradient(
      to right,
      rgba(0 0 0 / 100%) 40%,
      rgba(0 0 0 / 70%) 55%,
      rgba(0 0 0 / 40%) 70%,
      rgba(0 0 0 / 0%) 100%
    );
            mask-image: linear-gradient(
      to right,
      rgba(0 0 0 / 100%) 40%,
      rgba(0 0 0 / 70%) 55%,
      rgba(0 0 0 / 40%) 70%,
      rgba(0 0 0 / 0%) 100%
    );
    -webkit-mask-size: 200% 100%;
            mask-size: 200% 100%;
    -webkit-mask-position: 0 0;
            mask-position: 0 0;
  }

@keyframes tw-fade-out-mask-right-animation {
    0% {
      -webkit-mask-size: 200% 100%;
              mask-size: 200% 100%;
    }

    100% {
      -webkit-mask-size: 100% 100%;
              mask-size: 100% 100%;
    }
  }

.tw-apply-mask-right-animate {
    animation: tw-fade-out-mask-right-animation 0.15s forwards;
  }

.tw-fade-out-mask-left {
    padding: 2px; /* creates space for outline */
    margin: -2px; /* pulls it back to original position */
    -webkit-mask-image: linear-gradient(
      to left,
      rgba(0 0 0 / 100%) 40%,
      rgba(0 0 0 / 70%) 55%,
      rgba(0 0 0 / 40%) 70%,
      rgba(0 0 0 / 0%) 100%
    );
            mask-image: linear-gradient(
      to left,
      rgba(0 0 0 / 100%) 40%,
      rgba(0 0 0 / 70%) 55%,
      rgba(0 0 0 / 40%) 70%,
      rgba(0 0 0 / 0%) 100%
    );
    -webkit-mask-size: 200% 100%;
            mask-size: 200% 100%;
    -webkit-mask-position: 100% 0;
            mask-position: 100% 0;
  }

@keyframes tw-fade-out-mask-left-animation {
    0% {
      -webkit-mask-size: 200% 100%;
              mask-size: 200% 100%;
    }

    100% {
      -webkit-mask-size: 100% 100%;
              mask-size: 100% 100%;
    }
  }

.tw-apply-mask-left-animate {
    animation: tw-fade-out-mask-left-animation 0.15s forwards;
  }

@keyframes pulse-left {
    0% {
      transform: translateX(0);
    }

    50% {
      transform: translateX(-10px);
    }

    100% {
      transform: translateX(0);
    }
  }

.tw-tiktok-text {
    font-weight: 900;
    text-shadow:
      2px 2px 0 #fe2c55,
      -2px -2px 0 #25f4ee,
      0 0 5px #000;
    letter-spacing: 0.05em;
  }

.tw-instagram-text {
    font-weight: 900;
    background: linear-gradient(45deg, #f58529, #feda77, #dd2a7b, #8134af, #515bd4);
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    letter-spacing: 0.05em;
    animation: gradient-move 6s ease-in-out infinite;
  }

@keyframes gradient-move {
    0% {
      background-position: 0% 50%;
    }

    50% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  }

.tw-marquee-left {
    animation: marquee-left 8s linear infinite;
    will-change: transform;
    transform: translateX(-125%);
  }

.tw-marquee-right {
    animation: marquee-right 8s linear infinite;
    will-change: transform;
    transform: translateX(125%);
  }

@keyframes marquee-left {
    0% {
      transform: translateX(-125%);
    }

    100% {
      transform: translateX(125%);
    }
  }

@keyframes marquee-right {
    0% {
      transform: translateX(125%);
    }

    100% {
      transform: translateX(-125%);
    }
  }
.tw-pointer-events-none {
  pointer-events: none;
}
.tw-invisible {
  visibility: hidden;
}
.tw-fixed {
  position: fixed;
}
.tw-absolute {
  position: absolute;
}
.tw-relative {
  position: relative;
}
.tw-sticky {
  position: sticky;
}
.-tw-top-6 {
  top: -1.5rem;
}
.-tw-top-\\[0\\.08em\\] {
  top: -0.08em;
}
.-tw-top-\\[0\\.09em\\] {
  top: -0.09em;
}
.-tw-top-\\[0\\.4rem\\] {
  top: -0.4rem;
}
.tw-bottom-0 {
  bottom: 0px;
}
.tw-bottom-10 {
  bottom: 2.5rem;
}
.tw-bottom-16 {
  bottom: 4rem;
}
.tw-bottom-2 {
  bottom: 0.5rem;
}
.tw-bottom-4 {
  bottom: 1rem;
}
.tw-left-0 {
  left: 0px;
}
.tw-left-1 {
  left: 0.25rem;
}
.tw-left-1\\/2 {
  left: 50%;
}
.tw-left-2 {
  left: 0.5rem;
}
.tw-left-4 {
  left: 1rem;
}
.tw-left-\\[0\\.25rem\\] {
  left: 0.25rem;
}
.tw-left-\\[0\\.2rem\\] {
  left: 0.2rem;
}
.tw-left-\\[25px\\] {
  left: 25px;
}
.tw-right-0 {
  right: 0px;
}
.tw-right-12 {
  right: 3rem;
}
.tw-right-16 {
  right: 4rem;
}
.tw-right-2 {
  right: 0.5rem;
}
.tw-right-3 {
  right: 0.75rem;
}
.tw-right-4 {
  right: 1rem;
}
.tw-right-5 {
  right: 1.25rem;
}
.tw-right-6 {
  right: 1.5rem;
}
.tw-right-\\[-0\\.65rem\\] {
  right: -0.65rem;
}
.tw-right-\\[2px\\] {
  right: 2px;
}
.tw-top-0 {
  top: 0px;
}
.tw-top-0\\.5 {
  top: 0.125rem;
}
.tw-top-1 {
  top: 0.25rem;
}
.tw-top-1\\/2 {
  top: 50%;
}
.tw-top-12 {
  top: 3rem;
}
.tw-top-2 {
  top: 0.5rem;
}
.tw-top-4 {
  top: 1rem;
}
.tw-top-\\[-0\\.40rem\\] {
  top: -0.40rem;
}
.tw-top-\\[-3px\\] {
  top: -3px;
}
.tw-top-\\[0\\.125rem\\] {
  top: 0.125rem;
}
.tw-top-\\[10vh\\] {
  top: 10vh;
}
.tw-top-\\[2px\\] {
  top: 2px;
}
.tw-top-\\[35\\%\\] {
  top: 35%;
}
.tw-top-\\[7rem\\] {
  top: 7rem;
}
.tw-top-\\[80vh\\] {
  top: 80vh;
}
.tw-top-\\[87vh\\] {
  top: 87vh;
}
.tw-top-\\[calc\\(50\\%-5rem\\)\\] {
  top: calc(50% - 5rem);
}
.\\!tw-z-\\[100\\] {
  z-index: 100 !important;
}
.\\!tw-z-\\[49\\] {
  z-index: 49 !important;
}
.tw-z-10 {
  z-index: 10;
}
.tw-z-20 {
  z-index: 20;
}
.tw-z-40 {
  z-index: 40;
}
.tw-z-50 {
  z-index: 50;
}
.tw-z-\\[-1\\] {
  z-index: -1;
}
.tw-z-\\[1020\\] {
  z-index: 1020;
}
.tw-z-\\[1070\\] {
  z-index: 1070;
}
.tw-z-\\[45\\] {
  z-index: 45;
}
.tw-z-\\[4\\] {
  z-index: 4;
}
.tw-z-\\[51\\] {
  z-index: 51;
}
.tw-z-\\[52\\] {
  z-index: 52;
}
.tw-z-\\[60\\] {
  z-index: 60;
}
.tw-z-\\[6\\] {
  z-index: 6;
}
.tw-col-span-1 {
  grid-column: span 1 / span 1;
}
.tw-col-span-12 {
  grid-column: span 12 / span 12;
}
.tw-col-span-2 {
  grid-column: span 2 / span 2;
}
.tw-col-span-4 {
  grid-column: span 4 / span 4;
}
.\\!tw-my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.\\!tw-my-12 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
.\\!tw-my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.\\!tw-my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.\\!tw-my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.\\!tw-my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
.tw-mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.tw-mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.tw-mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.tw-mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.tw-mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.tw-mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.tw-mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.tw-my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.tw-my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.tw-my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.tw-my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.tw-my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.tw-my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.tw-my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.tw-my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.tw-my-\\[3rem\\] {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.\\!tw-mb-0 {
  margin-bottom: 0px !important;
}
.\\!tw-mb-4 {
  margin-bottom: 1rem !important;
}
.\\!tw-mb-6 {
  margin-bottom: 1.5rem !important;
}
.\\!tw-mt-0 {
  margin-top: 0px !important;
}
.\\!tw-mt-2 {
  margin-top: 0.5rem !important;
}
.\\!tw-mt-6 {
  margin-top: 1.5rem !important;
}
.\\!tw-mt-8 {
  margin-top: 2rem !important;
}
.-tw-ml-2 {
  margin-left: -0.5rem;
}
.-tw-ml-8 {
  margin-left: -2rem;
}
.-tw-ml-\\[0\\.2rem\\] {
  margin-left: -0.2rem;
}
.-tw-mt-0\\.5 {
  margin-top: -0.125rem;
}
.-tw-mt-1 {
  margin-top: -0.25rem;
}
.-tw-mt-2 {
  margin-top: -0.5rem;
}
.-tw-mt-3 {
  margin-top: -0.75rem;
}
.-tw-mt-\\[0\\.25rem\\] {
  margin-top: -0.25rem;
}
.-tw-mt-\\[0\\.55rem\\] {
  margin-top: -0.55rem;
}
.tw-mb-0 {
  margin-bottom: 0px;
}
.tw-mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.tw-mb-1 {
  margin-bottom: 0.25rem;
}
.tw-mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.tw-mb-12 {
  margin-bottom: 3rem;
}
.tw-mb-2 {
  margin-bottom: 0.5rem;
}
.tw-mb-3 {
  margin-bottom: 0.75rem;
}
.tw-mb-4 {
  margin-bottom: 1rem;
}
.tw-mb-5 {
  margin-bottom: 1.25rem;
}
.tw-mb-6 {
  margin-bottom: 1.5rem;
}
.tw-mb-8 {
  margin-bottom: 2rem;
}
.tw-mb-\\[20px\\] {
  margin-bottom: 20px;
}
.tw-ml-1 {
  margin-left: 0.25rem;
}
.tw-ml-2 {
  margin-left: 0.5rem;
}
.tw-ml-3 {
  margin-left: 0.75rem;
}
.tw-ml-4 {
  margin-left: 1rem;
}
.tw-ml-5 {
  margin-left: 1.25rem;
}
.tw-ml-6 {
  margin-left: 1.5rem;
}
.tw-ml-\\[2px\\] {
  margin-left: 2px;
}
.tw-mr-1 {
  margin-right: 0.25rem;
}
.tw-mr-1\\.5 {
  margin-right: 0.375rem;
}
.tw-mr-2 {
  margin-right: 0.5rem;
}
.tw-mr-3 {
  margin-right: 0.75rem;
}
.tw-mr-4 {
  margin-right: 1rem;
}
.tw-mr-6 {
  margin-right: 1.5rem;
}
.tw-mt-0 {
  margin-top: 0px;
}
.tw-mt-1 {
  margin-top: 0.25rem;
}
.tw-mt-10 {
  margin-top: 2.5rem;
}
.tw-mt-12 {
  margin-top: 3rem;
}
.tw-mt-2 {
  margin-top: 0.5rem;
}
.tw-mt-3 {
  margin-top: 0.75rem;
}
.tw-mt-4 {
  margin-top: 1rem;
}
.tw-mt-5 {
  margin-top: 1.25rem;
}
.tw-mt-6 {
  margin-top: 1.5rem;
}
.tw-mt-8 {
  margin-top: 2rem;
}
.tw-mt-\\[-0\\.125em\\] {
  margin-top: -0.125em;
}
.tw-mt-\\[0\\.1rem\\] {
  margin-top: 0.1rem;
}
.tw-mt-\\[1vh\\] {
  margin-top: 1vh;
}
.\\!tw-line-clamp-1 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 1 !important;
}
.tw-line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.tw-block {
  display: block;
}
.tw-inline-block {
  display: inline-block;
}
.tw-inline {
  display: inline;
}
.tw-flex {
  display: flex;
}
.tw-inline-flex {
  display: inline-flex;
}
.tw-grid {
  display: grid;
}
.tw-hidden {
  display: none;
}
.tw-aspect-\\[9\\/16\\] {
  aspect-ratio: 9/16;
}
.tw-aspect-square {
  aspect-ratio: 1 / 1;
}
.tw-aspect-video {
  aspect-ratio: 16 / 9;
}
.\\!tw-h-\\[90vh\\] {
  height: 90vh !important;
}
.\\!tw-h-full {
  height: 100% !important;
}
.tw-h-0 {
  height: 0px;
}
.tw-h-1\\/2 {
  height: 50%;
}
.tw-h-10 {
  height: 2.5rem;
}
.tw-h-14 {
  height: 3.5rem;
}
.tw-h-16 {
  height: 4rem;
}
.tw-h-2 {
  height: 0.5rem;
}
.tw-h-3 {
  height: 0.75rem;
}
.tw-h-4 {
  height: 1rem;
}
.tw-h-5 {
  height: 1.25rem;
}
.tw-h-6 {
  height: 1.5rem;
}
.tw-h-8 {
  height: 2rem;
}
.tw-h-\\[1\\.35rem\\] {
  height: 1.35rem;
}
.tw-h-\\[1\\.6rem\\] {
  height: 1.6rem;
}
.tw-h-\\[120px\\] {
  height: 120px;
}
.tw-h-\\[280px\\] {
  height: 280px;
}
.tw-h-\\[2px\\] {
  height: 2px;
}
.tw-h-\\[2rem\\] {
  height: 2rem;
}
.tw-h-\\[30px\\] {
  height: 30px;
}
.tw-h-\\[32px\\] {
  height: 32px;
}
.tw-h-\\[36px\\] {
  height: 36px;
}
.tw-h-\\[5rem\\] {
  height: 5rem;
}
.tw-h-\\[6px\\] {
  height: 6px;
}
.tw-h-\\[86vh\\] {
  height: 86vh;
}
.tw-h-\\[8px\\] {
  height: 8px;
}
.tw-h-\\[calc\\(100vh-3rem\\)\\] {
  height: calc(100vh - 3rem);
}
.tw-h-full {
  height: 100%;
}
.tw-h-screen {
  height: 100vh;
}
.tw-max-h-20 {
  max-height: 5rem;
}
.tw-max-h-80 {
  max-height: 20rem;
}
.tw-max-h-\\[12rem\\] {
  max-height: 12rem;
}
.tw-max-h-\\[16rem\\] {
  max-height: 16rem;
}
.tw-max-h-\\[180px\\] {
  max-height: 180px;
}
.tw-max-h-\\[280px\\] {
  max-height: 280px;
}
.tw-max-h-\\[300px\\] {
  max-height: 300px;
}
.tw-max-h-\\[400px\\] {
  max-height: 400px;
}
.tw-max-h-\\[500px\\] {
  max-height: 500px;
}
.tw-max-h-\\[700px\\] {
  max-height: 700px;
}
.tw-max-h-\\[90vh\\] {
  max-height: 90vh;
}
.\\!tw-min-h-6 {
  min-height: 1.5rem !important;
}
.\\!tw-min-h-\\[1\\.5rem\\] {
  min-height: 1.5rem !important;
}
.\\!tw-min-h-\\[1\\.75rem\\] {
  min-height: 1.75rem !important;
}
.\\!tw-min-h-\\[1\\.7rem\\] {
  min-height: 1.7rem !important;
}
.\\!tw-min-h-\\[calc\\(1\\.75rem-4px\\)\\] {
  min-height: calc(1.75rem - 4px) !important;
}
.tw-min-h-0 {
  min-height: 0px;
}
.tw-min-h-\\[1\\.75rem\\] {
  min-height: 1.75rem;
}
.tw-min-h-\\[2\\.5rem\\] {
  min-height: 2.5rem;
}
.tw-min-h-\\[20rem\\] {
  min-height: 20rem;
}
.tw-min-h-screen {
  min-height: 100vh;
}
.\\!tw-w-4 {
  width: 1rem !important;
}
.\\!tw-w-full {
  width: 100% !important;
}
.tw-w-0 {
  width: 0px;
}
.tw-w-1\\/2 {
  width: 50%;
}
.tw-w-10 {
  width: 2.5rem;
}
.tw-w-12 {
  width: 3rem;
}
.tw-w-14 {
  width: 3.5rem;
}
.tw-w-16 {
  width: 4rem;
}
.tw-w-2 {
  width: 0.5rem;
}
.tw-w-20 {
  width: 5rem;
}
.tw-w-3 {
  width: 0.75rem;
}
.tw-w-32 {
  width: 8rem;
}
.tw-w-36 {
  width: 9rem;
}
.tw-w-4 {
  width: 1rem;
}
.tw-w-40 {
  width: 10rem;
}
.tw-w-44 {
  width: 11rem;
}
.tw-w-48 {
  width: 12rem;
}
.tw-w-5 {
  width: 1.25rem;
}
.tw-w-6 {
  width: 1.5rem;
}
.tw-w-7 {
  width: 1.75rem;
}
.tw-w-\\[1\\.75rem\\] {
  width: 1.75rem;
}
.tw-w-\\[10px\\] {
  width: 10px;
}
.tw-w-\\[120px\\] {
  width: 120px;
}
.tw-w-\\[180px\\] {
  width: 180px;
}
.tw-w-\\[20px\\] {
  width: 20px;
}
.tw-w-\\[220px\\] {
  width: 220px;
}
.tw-w-\\[2px\\] {
  width: 2px;
}
.tw-w-\\[2rem\\] {
  width: 2rem;
}
.tw-w-\\[3\\.5rem\\] {
  width: 3.5rem;
}
.tw-w-\\[30px\\] {
  width: 30px;
}
.tw-w-\\[320px\\] {
  width: 320px;
}
.tw-w-\\[36px\\] {
  width: 36px;
}
.tw-w-\\[4\\.5rem\\] {
  width: 4.5rem;
}
.tw-w-\\[4px\\] {
  width: 4px;
}
.tw-w-\\[5rem\\] {
  width: 5rem;
}
.tw-w-\\[8px\\] {
  width: 8px;
}
.tw-w-\\[90\\%\\] {
  width: 90%;
}
.tw-w-auto {
  width: auto;
}
.tw-w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.tw-w-full {
  width: 100%;
}
.tw-w-screen {
  width: 100vw;
}
.\\!tw-min-w-\\[2\\.5rem\\] {
  min-width: 2.5rem !important;
}
.tw-min-w-\\[0\\.7rem\\] {
  min-width: 0.7rem;
}
.tw-min-w-\\[1\\.25em\\] {
  min-width: 1.25em;
}
.tw-min-w-\\[22rem\\] {
  min-width: 22rem;
}
.tw-min-w-\\[40\\%\\] {
  min-width: 40%;
}
.tw-min-w-\\[4rem\\] {
  min-width: 4rem;
}
.\\!tw-max-w-\\[4\\.5rem\\] {
  max-width: 4.5rem !important;
}
.\\!tw-max-w-fit {
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
}
.tw-max-w-2xl {
  max-width: 42rem;
}
.tw-max-w-3xl {
  max-width: 48rem;
}
.tw-max-w-48 {
  max-width: 12rem;
}
.tw-max-w-72 {
  max-width: 18rem;
}
.tw-max-w-80 {
  max-width: 20rem;
}
.tw-max-w-96 {
  max-width: 24rem;
}
.tw-max-w-\\[10rem\\] {
  max-width: 10rem;
}
.tw-max-w-\\[16rem\\] {
  max-width: 16rem;
}
.tw-max-w-\\[180px\\] {
  max-width: 180px;
}
.tw-max-w-\\[190px\\] {
  max-width: 190px;
}
.tw-max-w-\\[24rem\\] {
  max-width: 24rem;
}
.tw-max-w-\\[30rem\\] {
  max-width: 30rem;
}
.tw-max-w-\\[32rem\\] {
  max-width: 32rem;
}
.tw-max-w-\\[48rem\\] {
  max-width: 48rem;
}
.tw-max-w-\\[8rem\\] {
  max-width: 8rem;
}
.tw-max-w-\\[90\\%\\] {
  max-width: 90%;
}
.tw-max-w-full {
  max-width: 100%;
}
.tw-max-w-md {
  max-width: 28rem;
}
.tw-max-w-sm {
  max-width: 24rem;
}
.tw-flex-1 {
  flex: 1 1 0%;
}
.tw-flex-initial {
  flex: 0 1 auto;
}
.tw-shrink {
  flex-shrink: 1;
}
.tw-shrink-0 {
  flex-shrink: 0;
}
.tw-flex-grow {
  flex-grow: 1;
}
.tw-grow {
  flex-grow: 1;
}
.tw-table-auto {
  table-layout: auto;
}
.-tw-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-tw-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-tw-translate-y-\\[70\\%\\] {
  --tw-translate-y: -70%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes tw-spin {

  to {
    transform: rotate(360deg);
  }
}
.tw-animate-spin {
  animation: tw-spin 1s linear infinite;
}
.tw-cursor-auto {
  cursor: auto;
}
.tw-cursor-default {
  cursor: default;
}
.tw-cursor-pointer {
  cursor: pointer;
}
.tw-cursor-zoom-in {
  cursor: zoom-in;
}
.tw-select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.tw-list-inside {
  list-style-position: inside;
}
.tw-list-outside {
  list-style-position: outside;
}
.tw-list-decimal {
  list-style-type: decimal;
}
.tw-list-disc {
  list-style-type: disc;
}
.tw-appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.tw-grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.tw-grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.tw-grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.tw-grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.tw-grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.tw-grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.tw-flex-row {
  flex-direction: row;
}
.tw-flex-row-reverse {
  flex-direction: row-reverse;
}
.tw-flex-col {
  flex-direction: column;
}
.tw-flex-col-reverse {
  flex-direction: column-reverse;
}
.tw-flex-wrap {
  flex-wrap: wrap;
}
.tw-flex-nowrap {
  flex-wrap: nowrap;
}
.tw-items-start {
  align-items: flex-start;
}
.tw-items-end {
  align-items: flex-end;
}
.tw-items-center {
  align-items: center;
}
.tw-items-stretch {
  align-items: stretch;
}
.tw-justify-start {
  justify-content: flex-start;
}
.tw-justify-end {
  justify-content: flex-end;
}
.tw-justify-center {
  justify-content: center;
}
.tw-justify-between {
  justify-content: space-between;
}
.tw-justify-evenly {
  justify-content: space-evenly;
}
.tw-gap-1 {
  gap: 0.25rem;
}
.tw-gap-2 {
  gap: 0.5rem;
}
.tw-gap-3 {
  gap: 0.75rem;
}
.tw-gap-4 {
  gap: 1rem;
}
.tw-gap-6 {
  gap: 1.5rem;
}
.tw-gap-x-1 {
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}
.tw-gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.tw-gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.tw-gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.tw-gap-y-1 {
  row-gap: 0.25rem;
}
.tw-gap-y-12 {
  row-gap: 3rem;
}
.tw-gap-y-2 {
  row-gap: 0.5rem;
}
.tw-gap-y-3 {
  row-gap: 0.75rem;
}
.tw-gap-y-4 {
  row-gap: 1rem;
}
.tw-gap-y-6 {
  row-gap: 1.5rem;
}
.tw-gap-y-8 {
  row-gap: 2rem;
}
.tw-self-end {
  align-self: flex-end;
}
.tw-self-center {
  align-self: center;
}
.tw-justify-self-end {
  justify-self: end;
}
.tw-overflow-auto {
  overflow: auto;
}
.tw-overflow-hidden {
  overflow: hidden;
}
.tw-overflow-x-auto {
  overflow-x: auto;
}
.tw-overflow-x-hidden {
  overflow-x: hidden;
}
.tw-overflow-y-hidden {
  overflow-y: hidden;
}
.tw-overflow-x-scroll {
  overflow-x: scroll;
}
.tw-overflow-y-scroll {
  overflow-y: scroll;
}
.tw-overscroll-x-none {
  overscroll-behavior-x: none;
}
.tw-text-ellipsis {
  text-overflow: ellipsis;
}
.tw-whitespace-normal {
  white-space: normal;
}
.tw-whitespace-nowrap {
  white-space: nowrap;
}
.tw-whitespace-pre-wrap {
  white-space: pre-wrap;
}
.tw-text-nowrap {
  text-wrap: nowrap;
}
.tw-text-balance {
  text-wrap: balance;
}
.tw-break-words {
  overflow-wrap: break-word;
}
.tw-break-all {
  word-break: break-all;
}
.\\!tw-rounded-lg {
  border-radius: 0.5rem !important;
}
.tw-rounded {
  border-radius: 0.25rem;
}
.tw-rounded-2xl {
  border-radius: 1rem;
}
.tw-rounded-3xl {
  border-radius: 1.5rem;
}
.tw-rounded-\\[1px\\] {
  border-radius: 1px;
}
.tw-rounded-full {
  border-radius: 9999px;
}
.tw-rounded-lg {
  border-radius: 0.5rem;
}
.tw-rounded-md {
  border-radius: 0.375rem;
}
.tw-rounded-none {
  border-radius: 0px;
}
.tw-rounded-sm {
  border-radius: 0.125rem;
}
.tw-rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.tw-rounded-b-\\[1rem\\] {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.tw-rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.tw-rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.tw-rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.tw-rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.tw-rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.tw-rounded-l-sm {
  border-top-left-radius: 0.125rem;
  border-bottom-left-radius: 0.125rem;
}
.tw-rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.tw-rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.tw-rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.tw-rounded-r-sm {
  border-top-right-radius: 0.125rem;
  border-bottom-right-radius: 0.125rem;
}
.tw-rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.tw-rounded-t-\\[1rem\\] {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.tw-rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.tw-rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.tw-rounded-bl-md {
  border-bottom-left-radius: 0.375rem;
}
.tw-rounded-bl-sm {
  border-bottom-left-radius: 0.125rem;
}
.tw-rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.tw-rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
.tw-rounded-tl-md {
  border-top-left-radius: 0.375rem;
}
.tw-rounded-tl-sm {
  border-top-left-radius: 0.125rem;
}
.tw-rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.\\!tw-border {
  border-width: 1px !important;
}
.tw-border {
  border-width: 1px;
}
.tw-border-0 {
  border-width: 0px;
}
.tw-border-2 {
  border-width: 2px;
}
.tw-border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.tw-border-\\[10px\\] {
  border-width: 10px;
}
.tw-border-\\[6px\\] {
  border-width: 6px;
}
.tw-border-\\[8px\\] {
  border-width: 8px;
}
.tw-border-x-0 {
  border-left-width: 0px;
  border-right-width: 0px;
}
.tw-border-y-0 {
  border-top-width: 0px;
  border-bottom-width: 0px;
}
.\\!tw-border-l-0 {
  border-left-width: 0px !important;
}
.\\!tw-border-r-0 {
  border-right-width: 0px !important;
}
.\\!tw-border-t-0 {
  border-top-width: 0px !important;
}
.tw-border-b {
  border-bottom-width: 1px;
}
.tw-border-b-0 {
  border-bottom-width: 0px;
}
.tw-border-b-\\[3px\\] {
  border-bottom-width: 3px;
}
.tw-border-l {
  border-left-width: 1px;
}
.tw-border-l-0 {
  border-left-width: 0px;
}
.tw-border-l-2 {
  border-left-width: 2px;
}
.tw-border-l-4 {
  border-left-width: 4px;
}
.tw-border-l-\\[3px\\] {
  border-left-width: 3px;
}
.tw-border-l-\\[4px\\] {
  border-left-width: 4px;
}
.tw-border-r-0 {
  border-right-width: 0px;
}
.tw-border-r-\\[3px\\] {
  border-right-width: 3px;
}
.tw-border-r-\\[calc\\(0\\.5rem-4px\\)\\] {
  border-right-width: calc(0.5rem - 4px);
}
.tw-border-t-0 {
  border-top-width: 0px;
}
.tw-border-t-2 {
  border-top-width: 2px;
}
.tw-border-solid {
  border-style: solid;
}
.tw-border-dashed {
  border-style: dashed;
}
.\\!tw-border-layout-line-light {
  --tw-border-opacity: 1 !important;
  border-color: rgb(208 208 208 / var(--tw-border-opacity)) !important;
}
.tw-border-\\[\\#858585\\] {
  --tw-border-opacity: 1;
  border-color: rgb(133 133 133 / var(--tw-border-opacity));
}
.tw-border-gold40 {
  --tw-border-opacity: 1;
  border-color: rgb(217 210 188 / var(--tw-border-opacity));
}
.tw-border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.tw-border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
.tw-border-green-700 {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity));
}
.tw-border-greengreen {
  --tw-border-opacity: 1;
  border-color: rgb(52 199 89 / var(--tw-border-opacity));
}
.tw-border-layout-line-dark {
  --tw-border-opacity: 1;
  border-color: rgb(53 53 53 / var(--tw-border-opacity));
}
.tw-border-layout-line-light {
  --tw-border-opacity: 1;
  border-color: rgb(208 208 208 / var(--tw-border-opacity));
}
.tw-border-perpul-light {
  --tw-border-opacity: 1;
  border-color: rgb(91 117 254 / var(--tw-border-opacity));
}
.tw-border-perpul40 {
  --tw-border-opacity: 1;
  border-color: rgb(174 186 255 / var(--tw-border-opacity));
}
.tw-border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.tw-border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
.tw-border-redred {
  --tw-border-opacity: 1;
  border-color: rgb(178 34 34 / var(--tw-border-opacity));
}
.tw-border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
.tw-border-slate-800\\/10 {
  border-color: rgb(30 41 59 / 0.1);
}
.tw-border-transparent {
  border-color: transparent;
}
.tw-border-zinc-800 {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity));
}
.tw-border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}
.tw-border-y-transparent {
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.tw-border-l-body-light {
  --tw-border-opacity: 1;
  border-left-color: rgb(33 37 41 / var(--tw-border-opacity));
}
.tw-border-l-layout-line-light {
  --tw-border-opacity: 1;
  border-left-color: rgb(208 208 208 / var(--tw-border-opacity));
}
.tw-border-l-perpul-light {
  --tw-border-opacity: 1;
  border-left-color: rgb(91 117 254 / var(--tw-border-opacity));
}
.tw-border-l-transparent {
  border-left-color: transparent;
}
.tw-border-r-transparent {
  border-right-color: transparent;
}
.tw-border-r-zinc-100 {
  --tw-border-opacity: 1;
  border-right-color: rgb(244 244 245 / var(--tw-border-opacity));
}
.tw-border-r-zinc-500 {
  --tw-border-opacity: 1;
  border-right-color: rgb(113 113 122 / var(--tw-border-opacity));
}
.tw-border-r-zinc-800 {
  --tw-border-opacity: 1;
  border-right-color: rgb(39 39 42 / var(--tw-border-opacity));
}
.tw-border-t-zinc-100 {
  --tw-border-opacity: 1;
  border-top-color: rgb(244 244 245 / var(--tw-border-opacity));
}
.tw-border-t-zinc-300 {
  --tw-border-opacity: 1;
  border-top-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.\\!tw-bg-\\[\\#fcfcfcf4\\] {
  background-color: #fcfcfcf4 !important;
}
.\\!tw-bg-slate-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity)) !important;
}
.\\!tw-bg-transparent {
  background-color: transparent !important;
}
.tw-bg-\\[\\#111111\\]\\/80 {
  background-color: rgb(17 17 17 / 0.8);
}
.tw-bg-\\[\\#212121\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#5b75fe\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(91 117 254 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#e0e0e0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#fdf8ba\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 248 186 / var(--tw-bg-opacity));
}
.tw-bg-beige-light {
  --tw-bg-opacity: 1;
  background-color: rgb(250 240 220 / var(--tw-bg-opacity));
}
.tw-bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.tw-bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.tw-bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.tw-bg-gold40 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 210 188 / var(--tw-bg-opacity));
}
.tw-bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.tw-bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.tw-bg-gray-500\\/10 {
  background-color: rgb(107 114 128 / 0.1);
}
.tw-bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.tw-bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.tw-bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.tw-bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.tw-bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.tw-bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.tw-bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.tw-bg-greengreen {
  --tw-bg-opacity: 1;
  background-color: rgb(52 199 89 / var(--tw-bg-opacity));
}
.tw-bg-perpul-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(91 117 254 / var(--tw-bg-opacity));
}
.tw-bg-perpul-light {
  --tw-bg-opacity: 1;
  background-color: rgb(91 117 254 / var(--tw-bg-opacity));
}
.tw-bg-perpul40 {
  --tw-bg-opacity: 1;
  background-color: rgb(174 186 255 / var(--tw-bg-opacity));
}
.tw-bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.tw-bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.tw-bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.tw-bg-redred {
  --tw-bg-opacity: 1;
  background-color: rgb(178 34 34 / var(--tw-bg-opacity));
}
.tw-bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.tw-bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.tw-bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.tw-bg-slate-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity));
}
.tw-bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.tw-bg-slate-800\\/80 {
  background-color: rgb(30 41 59 / 0.8);
}
.tw-bg-tangerine40-light {
  --tw-bg-opacity: 1;
  background-color: rgb(255 220 179 / var(--tw-bg-opacity));
}
.tw-bg-transparent {
  background-color: transparent;
}
.tw-bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.tw-bg-yellow-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity));
}
.tw-bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity));
}
.tw-bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
.tw-bg-zinc-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity));
}
.tw-bg-zinc-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity));
}
.tw-bg-zinc-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity));
}
.tw-bg-zinc-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity));
}
.tw-bg-zinc-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.tw-bg-zinc-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity));
}
.\\!tw-bg-opacity-60 {
  --tw-bg-opacity: 0.6 !important;
}
.\\!tw-bg-opacity-\\[0\\.85\\] {
  --tw-bg-opacity: 0.85 !important;
}
.tw-bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.tw-bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.tw-bg-opacity-\\[0\\.85\\] {
  --tw-bg-opacity: 0.85;
}
.tw-bg-clip-padding {
  background-clip: padding-box;
}
.tw-fill-current {
  fill: currentColor;
}
.tw-fill-layout-line-light {
  fill: #d0d0d0;
}
.tw-object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.tw-object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.tw-object-center {
  -o-object-position: center;
     object-position: center;
}
.tw-p-1 {
  padding: 0.25rem;
}
.tw-p-2 {
  padding: 0.5rem;
}
.tw-p-2\\.5 {
  padding: 0.625rem;
}
.tw-p-3 {
  padding: 0.75rem;
}
.tw-p-4 {
  padding: 1rem;
}
.tw-p-5 {
  padding: 1.25rem;
}
.tw-p-6 {
  padding: 1.5rem;
}
.tw-p-\\[3px\\] {
  padding: 3px;
}
.\\!tw-px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!tw-px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!tw-px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!tw-px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!tw-py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!tw-py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!tw-py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.tw-px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.tw-px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.tw-px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.tw-px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw-px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.tw-px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.tw-px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.tw-px-\\[2px\\] {
  padding-left: 2px;
  padding-right: 2px;
}
.tw-py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.tw-py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.tw-py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.tw-py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.tw-py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw-py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.tw-py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.tw-py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.tw-py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.tw-py-\\[0\\.3125rem\\] {
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
}
.tw-pb-1 {
  padding-bottom: 0.25rem;
}
.tw-pb-10 {
  padding-bottom: 2.5rem;
}
.tw-pb-2 {
  padding-bottom: 0.5rem;
}
.tw-pb-3 {
  padding-bottom: 0.75rem;
}
.tw-pb-4 {
  padding-bottom: 1rem;
}
.tw-pb-6 {
  padding-bottom: 1.5rem;
}
.tw-pl-0 {
  padding-left: 0px;
}
.tw-pl-1 {
  padding-left: 0.25rem;
}
.tw-pl-10 {
  padding-left: 2.5rem;
}
.tw-pl-2 {
  padding-left: 0.5rem;
}
.tw-pl-3 {
  padding-left: 0.75rem;
}
.tw-pl-4 {
  padding-left: 1rem;
}
.tw-pl-5 {
  padding-left: 1.25rem;
}
.tw-pl-6 {
  padding-left: 1.5rem;
}
.tw-pl-8 {
  padding-left: 2rem;
}
.tw-pr-1 {
  padding-right: 0.25rem;
}
.tw-pr-10 {
  padding-right: 2.5rem;
}
.tw-pr-2 {
  padding-right: 0.5rem;
}
.tw-pr-4 {
  padding-right: 1rem;
}
.tw-pr-6 {
  padding-right: 1.5rem;
}
.tw-pr-\\[4rem\\] {
  padding-right: 4rem;
}
.tw-pt-0 {
  padding-top: 0px;
}
.tw-pt-1 {
  padding-top: 0.25rem;
}
.tw-pt-2 {
  padding-top: 0.5rem;
}
.tw-pt-4 {
  padding-top: 1rem;
}
.tw-pt-6 {
  padding-top: 1.5rem;
}
.tw-pt-7 {
  padding-top: 1.75rem;
}
.tw-pt-8 {
  padding-top: 2rem;
}
.tw-text-left {
  text-align: left;
}
.tw-text-center {
  text-align: center;
}
.tw-text-right {
  text-align: right;
}
.tw-align-middle {
  vertical-align: middle;
}
.tw-align-bottom {
  vertical-align: bottom;
}
.tw-text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.tw-text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.tw-text-5xl {
  font-size: 3rem;
  line-height: 1rem;
}
.tw-text-\\[0\\.75rem\\] {
  font-size: 0.75rem;
}
.tw-text-\\[0\\.90rem\\] {
  font-size: 0.90rem;
}
.tw-text-\\[0\\.95rem\\] {
  font-size: 0.95rem;
}
.tw-text-\\[0\\.9rem\\] {
  font-size: 0.9rem;
}
.tw-text-\\[1\\.05rem\\] {
  font-size: 1.05rem;
}
.tw-text-\\[1\\.15rem\\] {
  font-size: 1.15rem;
}
.tw-text-\\[1\\.1rem\\] {
  font-size: 1.1rem;
}
.tw-text-\\[1\\.25rem\\] {
  font-size: 1.25rem;
}
.tw-text-\\[1\\.2rem\\] {
  font-size: 1.2rem;
}
.tw-text-\\[1\\.3rem\\] {
  font-size: 1.3rem;
}
.tw-text-\\[1\\.4rem\\] {
  font-size: 1.4rem;
}
.tw-text-\\[1\\.5rem\\] {
  font-size: 1.5rem;
}
.tw-text-\\[3rem\\] {
  font-size: 3rem;
}
.tw-text-\\[4rem\\] {
  font-size: 4rem;
}
.tw-text-\\[5rem\\] {
  font-size: 5rem;
}
.tw-text-\\[90\\%\\] {
  font-size: 90%;
}
.tw-text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.tw-text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.tw-text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw-text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.tw-text-xs {
  font-size: 0.8rem;
  line-height: 1rem;
}
.tw-font-bold {
  font-weight: 700;
}
.tw-font-medium {
  font-weight: 500;
}
.tw-font-normal {
  font-weight: 400;
}
.tw-font-semibold {
  font-weight: 600;
}
.tw-uppercase {
  text-transform: uppercase;
}
.tw-italic {
  font-style: italic;
}
.tw-leading-7 {
  line-height: 1.75rem;
}
.tw-leading-8 {
  line-height: 2rem;
}
.tw-leading-\\[4rem\\] {
  line-height: 4rem;
}
.tw-leading-none {
  line-height: 1;
}
.tw-leading-normal {
  line-height: 1.5;
}
.tw-leading-relaxed {
  line-height: 1.625;
}
.tw-leading-snug {
  line-height: 1.375;
}
.tw-leading-tight {
  line-height: 1.25;
}
.tw-text-\\[\\#121212\\] {
  --tw-text-opacity: 1;
  color: rgb(18 18 18 / var(--tw-text-opacity));
}
.tw-text-\\[\\#3b5998\\] {
  --tw-text-opacity: 1;
  color: rgb(59 89 152 / var(--tw-text-opacity));
}
.tw-text-\\[\\#ca8a04\\] {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.tw-text-\\[\\#ff0000\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.tw-text-\\[\\#ff5700\\] {
  --tw-text-opacity: 1;
  color: rgb(255 87 0 / var(--tw-text-opacity));
}
.tw-text-\\[firebrick\\] {
  --tw-text-opacity: 1;
  color: rgb(178 34 34 / var(--tw-text-opacity));
}
.tw-text-body-light {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}
.tw-text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.tw-text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.tw-text-inherit {
  color: inherit;
}
.tw-text-layout-line-light {
  --tw-text-opacity: 1;
  color: rgb(208 208 208 / var(--tw-text-opacity));
}
.tw-text-perpul {
  --tw-text-opacity: 1;
  color: rgb(91 117 254 / var(--tw-text-opacity));
}
.tw-text-perpul-light {
  --tw-text-opacity: 1;
  color: rgb(91 117 254 / var(--tw-text-opacity));
}
.tw-text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.tw-text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.tw-text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.tw-text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.tw-underline {
  text-decoration-line: underline;
}
.\\!tw-no-underline {
  text-decoration-line: none !important;
}
.tw-placeholder-gray-600::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(75 85 99 / var(--tw-placeholder-opacity));
}
.tw-placeholder-gray-600::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(75 85 99 / var(--tw-placeholder-opacity));
}
.tw-accent-perpul-light {
  accent-color: #5b75fe;
}
.tw-opacity-0 {
  opacity: 0;
}
.tw-opacity-100 {
  opacity: 1;
}
.tw-opacity-30 {
  opacity: 0.3;
}
.tw-opacity-50 {
  opacity: 0.5;
}
.tw-opacity-60 {
  opacity: 0.6;
}
.tw-opacity-70 {
  opacity: 0.7;
}
.tw-opacity-80 {
  opacity: 0.8;
}
.tw-opacity-90 {
  opacity: 0.9;
}
.\\!tw-shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.tw-shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-outline {
  outline-style: solid;
}
.tw-outline-2 {
  outline-width: 2px;
}
.tw-outline-black {
  outline-color: #000;
}
.tw-outline-perpul {
  outline-color: #5b75fe;
}
.tw-backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw-duration-300 {
  transition-duration: 300ms;
}
.odd\\:tw-bg-highlight:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(225 225 225 / var(--tw-bg-opacity));
}
.odd\\:tw-bg-highlight:nth-child(odd):is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .hover\\:tw-text-primary:hover {
    --tw-text-opacity: 1;
    color: rgb(33 37 41 / var(--tw-text-opacity));
  }

  .hover\\:tw-text-primary:hover:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(226 232 240 / var(--tw-text-opacity));
  }

  .hover\\:tw-text-light:hover {
    --tw-text-opacity: 1;
    color: rgb(228 228 231 / var(--tw-text-opacity));
  }

  .hover\\:tw-text-muted:hover {
    --tw-text-opacity: 1;
    color: rgb(105 105 115 / var(--tw-text-opacity));
  }

  .hover\\:tw-text-muted:hover:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(161 161 170 / var(--tw-text-opacity));
  }

  .hover\\:tw-bg-primary:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(254 254 254 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-primary:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(32 32 36 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-highlight:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(225 225 225 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-highlight:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(39 39 42 / var(--tw-bg-opacity));
  }

  .hover\\:tw-story-outline:hover {
    outline-style: solid;
    outline-width: 2px;
    outline-color: #cccccc;
  }

  .hover\\:tw-story-outline:hover:is(.tw-dark *) {
    outline-color: #333333;
  }
}
.disabled\\:tw-text-muted:disabled {
  --tw-text-opacity: 1;
  color: rgb(105 105 115 / var(--tw-text-opacity));
}
.disabled\\:tw-text-muted:disabled:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
.disabled\\:tw-bg-primary:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}
.disabled\\:tw-bg-primary:disabled:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 36 / var(--tw-bg-opacity));
}
.tw-group\\/card.is-panning .group-\\[\\.is-panning\\]\\/card\\:tw-bg-custom {
    background-color: var(--hover-bg) !important;
  }
.tw-group\\/card.is-panning .group-\\[\\.is-panning\\]\\/card\\:tw-bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}
.tw-group\\/card.is-panning .group-\\[\\.is-panning\\]\\/card\\:tw-bg-primary:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 36 / var(--tw-bg-opacity));
}
.dark\\:tw-text-dark:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}
.dark\\:tw-bg-striped-dark:is(.tw-dark *) {
    background-image: linear-gradient(
      45deg,
      #2f2f2f 25%,
      #353535 25%,
      #353535 50%,
      #2f2f2f 50%,
      #2f2f2f 75%,
      #353535 75%,
      #353535 100%
    );
    background-size: 56.57px 56.57px;
  }
@media (min-width: 640px) {

  .sm\\:tw-pulse-left {
    animation: pulse-left 2s infinite;
  }

    .sm\\:tw-pulse-left:hover {
      animation: none;
      transform: translateX(0);
      transition: transform 0.5s ease;
    }
}
.placeholder\\:tw-italic::-moz-placeholder {
  font-style: italic;
}
.placeholder\\:tw-italic::placeholder {
  font-style: italic;
}
.first\\:tw-mt-0:first-child {
  margin-top: 0px;
}
.checked\\:tw-bg-perpul-dark:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(91 117 254 / var(--tw-bg-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .hover\\:tw-border-greengreen:hover {
    --tw-border-opacity: 1;
    border-color: rgb(52 199 89 / var(--tw-border-opacity));
  }

  .hover\\:tw-border-layout-line-dark:hover {
    --tw-border-opacity: 1;
    border-color: rgb(53 53 53 / var(--tw-border-opacity));
  }

  .hover\\:tw-border-perpul-light:hover {
    --tw-border-opacity: 1;
    border-color: rgb(91 117 254 / var(--tw-border-opacity));
  }

  .hover\\:tw-border-redred:hover {
    --tw-border-opacity: 1;
    border-color: rgb(178 34 34 / var(--tw-border-opacity));
  }

  .hover\\:\\!tw-bg-perpul40:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(174 186 255 / var(--tw-bg-opacity)) !important;
  }

  .hover\\:\\!tw-bg-yellow-light:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(253 249 186 / var(--tw-bg-opacity)) !important;
  }

  .hover\\:tw-bg-\\[\\#e0e1e6\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(224 225 230 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-gray-200\\/50:hover {
    background-color: rgb(229 231 235 / 0.5);
  }

  .hover\\:tw-bg-gray-300:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-greengreen:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(52 199 89 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-neutral-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-perpul-light:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(91 117 254 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-perpul40:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(174 186 255 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-redred:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(178 34 34 / var(--tw-bg-opacity));
  }

  .hover\\:\\!tw-bg-opacity-100:hover {
    --tw-bg-opacity: 1 !important;
  }

  .hover\\:\\!tw-bg-opacity-50:hover {
    --tw-bg-opacity: 0.5 !important;
  }

  .hover\\:tw-bg-opacity-20:hover {
    --tw-bg-opacity: 0.2;
  }

  .hover\\:tw-font-semibold:hover {
    font-weight: 600;
  }

  .hover\\:tw-text-body-light:hover {
    --tw-text-opacity: 1;
    color: rgb(33 37 41 / var(--tw-text-opacity));
  }

  .hover\\:tw-text-current:hover {
    color: currentColor;
  }

  .hover\\:tw-text-inherit:hover {
    color: inherit;
  }

  .hover\\:tw-no-underline:hover {
    text-decoration-line: none;
  }

  .hover\\:tw-opacity-100:hover {
    opacity: 1;
  }

  .hover\\:tw-opacity-80:hover {
    opacity: 0.8;
  }

  .hover\\:tw-shadow-md:hover {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
.focus\\:tw-rounded:focus {
  border-radius: 0.25rem;
}
.focus\\:tw-rounded-sm:focus {
  border-radius: 0.125rem;
}
.focus\\:tw-outline:focus {
  outline-style: solid;
}
.focus\\:tw-outline-0:focus {
  outline-width: 0px;
}
.focus\\:tw-outline-zinc-800:focus {
  outline-color: #27272a;
}
.focus-visible\\:tw-outline:focus-visible {
  outline-style: solid;
}
.focus-visible\\:tw-outline-2:focus-visible {
  outline-width: 2px;
}
.focus-visible\\:tw-outline-offset-2:focus-visible {
  outline-offset: 2px;
}
.focus-visible\\:tw-outline-black:focus-visible {
  outline-color: #000;
}
.disabled\\:\\!tw-cursor-default:disabled {
  cursor: default !important;
}
.disabled\\:\\!tw-bg-opacity-60:disabled {
  --tw-bg-opacity: 0.6 !important;
}
.disabled\\:tw-text-zinc-100:disabled {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .disabled\\:hover\\:\\!tw-bg-opacity-60:hover:disabled {
    --tw-bg-opacity: 0.6 !important;
  }

  .tw-group\\/img-slider:hover .group-hover\\/img-slider\\:tw-visible {
    visibility: visible;
  }

  .tw-group\\/img:hover .group-hover\\/img\\:tw-visible {
    visibility: visible;
  }

  .tw-group:hover .group-hover\\:tw-visible {
    visibility: visible;
  }

  .tw-group:hover .group-hover\\:tw-h-\\[18px\\] {
    height: 18px;
  }

  .tw-group:hover .group-hover\\:tw-opacity-90 {
    opacity: 0.9;
  }
}
div[data-paused] .media-paused\\:tw-block {
  display: block;
}
.dark\\:\\!tw-border-layout-line-dark:is(.tw-dark *) {
  --tw-border-opacity: 1 !important;
  border-color: rgb(53 53 53 / var(--tw-border-opacity)) !important;
}
.dark\\:tw-border-\\[\\#767676\\]:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(118 118 118 / var(--tw-border-opacity));
}
.dark\\:tw-border-gray-100:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.dark\\:tw-border-gray-400:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.dark\\:tw-border-gray-600:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.dark\\:tw-border-green-700:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity));
}
.dark\\:tw-border-layout-line-dark:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(53 53 53 / var(--tw-border-opacity));
}
.dark\\:tw-border-layout-line-light:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(208 208 208 / var(--tw-border-opacity));
}
.dark\\:tw-border-perpul-dark:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(91 117 254 / var(--tw-border-opacity));
}
.dark\\:tw-border-red-700:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
.dark\\:tw-border-slate-100\\/10:is(.tw-dark *) {
  border-color: rgb(241 245 249 / 0.1);
}
.dark\\:tw-border-slate-500:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}
.dark\\:tw-border-transparent:is(.tw-dark *) {
  border-color: transparent;
}
.dark\\:tw-border-zinc-300:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.dark\\:tw-border-l-body-dark:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-left-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.dark\\:tw-border-l-layout-line-dark:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-left-color: rgb(53 53 53 / var(--tw-border-opacity));
}
.dark\\:tw-border-l-perpul-dark:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-left-color: rgb(91 117 254 / var(--tw-border-opacity));
}
.dark\\:tw-border-r-zinc-400:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-right-color: rgb(161 161 170 / var(--tw-border-opacity));
}
.dark\\:tw-border-t-zinc-300:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-top-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.dark\\:tw-border-t-zinc-700:is(.tw-dark *) {
  --tw-border-opacity: 1;
  border-top-color: rgb(63 63 70 / var(--tw-border-opacity));
}
.dark\\:\\!tw-bg-\\[\\#161616ef\\]:is(.tw-dark *) {
  background-color: #161616ef !important;
}
.dark\\:\\!tw-bg-slate-700:is(.tw-dark *) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity)) !important;
}
.dark\\:tw-bg-\\[\\#211f02\\]:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(33 31 2 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-beige-dark:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(44 38 26 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-gray-300:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-gray-500\\/10:is(.tw-dark *) {
  background-color: rgb(107 114 128 / 0.1);
}
.dark\\:tw-bg-gray-600:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-gray-700:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-gray-800:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-green-500:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-green-600:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-green-700:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-green-900:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-perpul-dark:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(91 117 254 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-perpul-light:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(91 117 254 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-perpul40-dark:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 70 152 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-red-700:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-red-800:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-slate-400:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-slate-700:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-slate-800:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-tangerine40-dark:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(74 52 26 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-yellow-600:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-yellow-700:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-zinc-200:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-zinc-300:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-zinc-500:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-zinc-700:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-zinc-800:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
.dark\\:tw-bg-opacity-40:is(.tw-dark *) {
  --tw-bg-opacity: 0.4;
}
.dark\\:tw-fill-layout-line-dark:is(.tw-dark *) {
  fill: #353535;
}
.dark\\:tw-text-body-dark:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}
.dark\\:tw-text-green-700:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.dark\\:tw-text-inherit:is(.tw-dark *) {
  color: inherit;
}
.dark\\:tw-text-layout-line-dark:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(53 53 53 / var(--tw-text-opacity));
}
.dark\\:tw-text-perpul-dark:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(91 117 254 / var(--tw-text-opacity));
}
.dark\\:tw-text-red-700:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.dark\\:tw-text-slate-400:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.dark\\:tw-text-stone-200:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(231 229 228 / var(--tw-text-opacity));
}
.dark\\:tw-placeholder-gray-400:is(.tw-dark *)::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.dark\\:tw-placeholder-gray-400:is(.tw-dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.dark\\:tw-accent-perpul-dark:is(.tw-dark *) {
  accent-color: #5b75fe;
}
.dark\\:checked\\:tw-bg-perpul-light:checked:is(.tw-dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(91 117 254 / var(--tw-bg-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .hover\\:dark\\:tw-border-layout-line-light:is(.tw-dark *):hover {
    --tw-border-opacity: 1;
    border-color: rgb(208 208 208 / var(--tw-border-opacity));
  }

  .dark\\:hover\\:tw-border-opacity-60:hover:is(.tw-dark *) {
    --tw-border-opacity: 0.6;
  }

  .dark\\:hover\\:\\!tw-bg-perpul40-dark:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(55 70 152 / var(--tw-bg-opacity)) !important;
  }

  .dark\\:hover\\:\\!tw-bg-yellow-dark:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(40 39 0 / var(--tw-bg-opacity)) !important;
  }

  .dark\\:hover\\:tw-bg-gray-700:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }

  .dark\\:hover\\:tw-bg-gray-700\\/50:hover:is(.tw-dark *) {
    background-color: rgb(55 65 81 / 0.5);
  }

  .dark\\:hover\\:tw-bg-neutral-800:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(38 38 38 / var(--tw-bg-opacity));
  }

  .dark\\:hover\\:tw-bg-perpul40-dark:hover:is(.tw-dark *) {
    --tw-bg-opacity: 1;
    background-color: rgb(55 70 152 / var(--tw-bg-opacity));
  }

  .hover\\:dark\\:tw-bg-\\[\\#2e3135\\]:is(.tw-dark *):hover {
    --tw-bg-opacity: 1;
    background-color: rgb(46 49 53 / var(--tw-bg-opacity));
  }

  .hover\\:dark\\:tw-bg-perpul-dark:is(.tw-dark *):hover {
    --tw-bg-opacity: 1;
    background-color: rgb(91 117 254 / var(--tw-bg-opacity));
  }

  .dark\\:hover\\:tw-bg-opacity-40:hover:is(.tw-dark *) {
    --tw-bg-opacity: 0.4;
  }

  .dark\\:hover\\:tw-text-body-dark:hover:is(.tw-dark *) {
    --tw-text-opacity: 1;
    color: rgb(226 232 240 / var(--tw-text-opacity));
  }

  .hover\\:dark\\:tw-text-body-dark:is(.tw-dark *):hover {
    --tw-text-opacity: 1;
    color: rgb(226 232 240 / var(--tw-text-opacity));
  }
}
.dark\\:focus\\:tw-outline-zinc-100:focus:is(.tw-dark *) {
  outline-color: #f4f4f5;
}
.focus-visible\\:dark\\:tw-outline-white:is(.tw-dark *):focus-visible {
  outline-color: #fff;
}
.disabled\\:dark\\:\\!tw-bg-opacity-60:is(.tw-dark *):disabled {
  --tw-bg-opacity: 0.6 !important;
}
.dark\\:disabled\\:tw-text-zinc-400:disabled:is(.tw-dark *) {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .disabled\\:dark\\:hover\\:\\!tw-bg-opacity-60:hover:is(.tw-dark *):disabled {
    --tw-bg-opacity: 0.6 !important;
  }
}
@media not all and (min-width: 1280px) {

  .max-xl\\:tw-flex-col {
    flex-direction: column;
  }
}
@media not all and (min-width: 1024px) {

  .max-lg\\:tw-justify-center {
    justify-content: center;
  }

  .max-lg\\:tw-px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}
@media not all and (min-width: 640px) {

  .max-sm\\:tw-flex-col {
    flex-direction: column;
  }

  .max-sm\\:tw-justify-between {
    justify-content: space-between;
  }

  .max-sm\\:tw-pr-2 {
    padding-right: 0.5rem;
  }
}
@media (min-width: 640px) {

  .sm\\:tw-col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:tw-col-span-11 {
    grid-column: span 11 / span 11;
  }

  .sm\\:tw-mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .sm\\:tw-my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .sm\\:tw-mt-0 {
    margin-top: 0px;
  }

  .sm\\:tw-mt-4 {
    margin-top: 1rem;
  }

  .sm\\:tw-mt-\\[3vh\\] {
    margin-top: 3vh;
  }

  .sm\\:tw-block {
    display: block;
  }

  .sm\\:tw-inline {
    display: inline;
  }

  .sm\\:tw-flex {
    display: flex;
  }

  .sm\\:tw-inline-flex {
    display: inline-flex;
  }

  .sm\\:\\!tw-hidden {
    display: none !important;
  }

  .sm\\:tw-hidden {
    display: none;
  }

  .sm\\:tw-h-\\[180px\\] {
    height: 180px;
  }

  .sm\\:tw-h-\\[90vh\\] {
    height: 90vh;
  }

  .sm\\:tw-h-full {
    height: 100%;
  }

  .sm\\:tw-h-screen {
    height: 100vh;
  }

  .sm\\:tw-w-\\[180px\\] {
    width: 180px;
  }

  .sm\\:tw-w-full {
    width: 100%;
  }

  .sm\\:tw-min-w-32 {
    min-width: 8rem;
  }

  .sm\\:tw-min-w-\\[10rem\\] {
    min-width: 10rem;
  }

  .sm\\:tw-min-w-fit {
    min-width: -moz-fit-content;
    min-width: fit-content;
  }

  .sm\\:tw-max-w-32 {
    max-width: 8rem;
  }

  .sm\\:tw-max-w-\\[15rem\\] {
    max-width: 15rem;
  }

  .sm\\:tw-max-w-\\[25rem\\] {
    max-width: 25rem;
  }

  .sm\\:tw-max-w-\\[560px\\] {
    max-width: 560px;
  }

  .sm\\:tw-basis-\\[14rem\\] {
    flex-basis: 14rem;
  }

  .sm\\:tw-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:tw-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:tw-items-center {
    align-items: center;
  }

  .sm\\:tw-justify-center {
    justify-content: center;
  }

  .sm\\:tw-gap-2 {
    gap: 0.5rem;
  }

  .sm\\:tw-gap-y-2 {
    row-gap: 0.5rem;
  }

  .sm\\:tw-gap-y-4 {
    row-gap: 1rem;
  }

  .sm\\:tw-overflow-visible {
    overflow: visible;
  }

  .sm\\:tw-overflow-y-scroll {
    overflow-y: scroll;
  }

  .sm\\:tw-rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }

  .sm\\:tw-rounded-bl-none {
    border-bottom-left-radius: 0px;
  }

  .sm\\:\\!tw-px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .sm\\:tw-px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:tw-px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:tw-py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:tw-pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:tw-pr-4 {
    padding-right: 1rem;
  }

  .sm\\:tw-pr-\\[5px\\] {
    padding-right: 5px;
  }

  .sm\\:tw-text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:tw-text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:\\!tw-leading-tight {
    line-height: 1.25 !important;
  }

  .sm\\:tw-leading-7 {
    line-height: 1.75rem;
  }

  @media not all and (min-width: 1024px) {

    .sm\\:max-lg\\:tw-flex {
      display: flex;
    }

    .sm\\:max-lg\\:tw-hidden {
      display: none;
    }

    .sm\\:max-lg\\:tw-justify-center {
      justify-content: center;
    }
  }
}
@media (min-width: 768px) {

  .md\\:tw-left-1\\/2 {
    left: 50%;
  }

  .md\\:tw-col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:tw-col-span-11 {
    grid-column: span 11 / span 11;
  }

  .md\\:tw-col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:tw-col-span-7 {
    grid-column: span 7 / span 7;
  }

  .md\\:tw-col-start-10 {
    grid-column-start: 10;
  }

  .md\\:tw-col-start-2 {
    grid-column-start: 2;
  }

  .md\\:tw-mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .md\\:tw-ml-\\[-33\\.33\\%\\] {
    margin-left: -33.33%;
  }

  .md\\:tw-block {
    display: block;
  }

  .md\\:tw-inline-block {
    display: inline-block;
  }

  .md\\:tw-hidden {
    display: none;
  }

  .md\\:\\!tw-w-60 {
    width: 15rem !important;
  }

  .md\\:tw-w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:tw-w-80 {
    width: 20rem;
  }

  .md\\:tw-max-w-\\[660px\\] {
    max-width: 660px;
  }

  .md\\:tw-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:tw-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:tw-px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:tw-pl-3 {
    padding-left: 0.75rem;
  }

  .md\\:tw-text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:tw-col-span-10 {
    grid-column: span 10 / span 10;
  }

  .lg\\:tw-col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:tw-col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:tw-col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:tw-col-start-2 {
    grid-column-start: 2;
  }

  .lg\\:tw-mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .lg\\:tw-ml-4 {
    margin-left: 1rem;
  }

  .lg\\:\\!tw-line-clamp-1 {
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1 !important;
  }

  .lg\\:tw-block {
    display: block;
  }

  .lg\\:tw-inline {
    display: inline;
  }

  .lg\\:tw-flex {
    display: flex;
  }

  .lg\\:tw-hidden {
    display: none;
  }

  .lg\\:tw-max-h-\\[12rem\\] {
    max-height: 12rem;
  }

  .lg\\:tw-max-h-\\[200px\\] {
    max-height: 200px;
  }

  .lg\\:tw-w-4\\/5 {
    width: 80%;
  }

  .lg\\:tw-w-64 {
    width: 16rem;
  }

  .lg\\:tw-w-\\[260px\\] {
    width: 260px;
  }

  .lg\\:tw-max-w-2xl {
    max-width: 42rem;
  }

  .lg\\:tw-max-w-\\[860px\\] {
    max-width: 860px;
  }

  .lg\\:tw-max-w-lg {
    max-width: 32rem;
  }

  .lg\\:tw-items-center {
    align-items: center;
  }

  .lg\\:tw-px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:tw-pb-1 {
    padding-bottom: 0.25rem;
  }

  .lg\\:tw-pl-4 {
    padding-left: 1rem;
  }

  .lg\\:tw-pl-6 {
    padding-left: 1.5rem;
  }

  .lg\\:tw-pr-0 {
    padding-right: 0px;
  }
}
@media (min-width: 1280px) {

  .xl\\:tw-col-span-10 {
    grid-column: span 10 / span 10;
  }

  .xl\\:tw-col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:tw-max-h-\\[280px\\] {
    max-height: 280px;
  }

  .xl\\:tw-w-\\[320px\\] {
    width: 320px;
  }
}
.\\[\\&\\>ol\\]\\:tw-pl-5>ol {
  padding-left: 1.25rem;
}
.\\[\\&\\>ul\\]\\:tw-pl-5>ul {
  padding-left: 1.25rem;
}
.\\[\\&_iframe\\]\\:tw-absolute iframe {
  position: absolute;
}
.\\[\\&_iframe\\]\\:tw-left-0 iframe {
  left: 0px;
}
.\\[\\&_iframe\\]\\:tw-top-0 iframe {
  top: 0px;
}
.\\[\\&_iframe\\]\\:tw-h-full iframe {
  height: 100%;
}
.\\[\\&_iframe\\]\\:tw-w-full iframe {
  width: 100%;
}
.\\[\\&_p\\]\\:tw-mb-0 p {
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,qBAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,qBAAA;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,0IAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAEd;;;;;;;CAOC;;AAED;;;CAGC;AACD;EACE,eAAe;AACjB;;AAGE;EAAA,oBAA0D;EAA1D,+CAAA;AAA0D;;AAA1D;EAAA,oBAA0D;EAA1D,+CAAA;AAA0D;;AAI1D;EAAA,+BAAA;AAAmB;;AAInB;EAAA,mBAAA;AAAc;;AAGhB;;;;CAIC;AACD;EACE,qBAAqB;AACvB;;AAEA,mEAAmE;AACnE;EACE,gCAAuD;EACvD,4BAA4B,EAAE,+BAA+B;EAC7D,gCAAgC,EAAE,6BAA6B;EAC/D,8BAA8B;EAC9B,kCAAsD;EACtD,sCAA0D;EAC1D,8BAAgD;AAClD;;AAEA;EACE,kCAAuD;EACvD,sCAA2D;EAC3D,gCAAwD;EACxD,4BAA4B,EAAE,+BAA+B;EAC7D,gCAAgC,EAAE,6BAA6B;AACjE;AACA,kEAAkE;;AAGhE;EAAA,aAAqC;EAArC,sBAAqC;EAArC,aAAqC;EACrC,oBAAiC;EAAjC,6CAAA;AADqC;;AACrC;EAAA,oBAAiC;EAAjC,gDAAA;AAAiC;;AAAjC;EAAA,mBAAiC;EAAjC,oBAAiC;EACjC,iBAAA;AADiC;;AAI/B;EAAA,aAAqC;EAArC,sBAAqC;EAArC,aAAqC;EACrC,kBAAsB;EAAtB,yDAAA;AADqC;;AACrC;EAAA,kBAAsB;EAAtB,sDAAA;AAAsB;;AACtB;EAAA,gBAAkB;EAClB,oBAA8B;EAA9B,uBAA8B;EAA9B,kBAA8B;EAA9B,qBAA8B;EAC9B,qBAAoF;EAApF,sBAAoF;EAApF,sBAAoF;EAApF,2DAAA;AAFkB;;AAElB;EAAA,sBAAoF;EAApF,8DAAA;AAAoF;;AASpF;;;;;;EAAA,gBAAA;AAA4B;;AAA5B;;;;;;EAAA,eAAA;AAA4B;;AAI5B;EAAA,iBAAoC;EAApC,gBAAA;AAAoC;;AAIpC;EAAA,kBAAqC;EAArC,gBAAA;AAAqC;;AAIrC;EAAA,iBAAoC;EAApC,gBAAA;AAAoC;;AAIpC;EAAA,kBAAqC;EAArC,gBAAA;AAAqC;;AAIrC;EAAA,kBAAyC;EAAzC,gBAAA;AAAyC;;AAIzC;EAAA,kBAAyC;EAAzC,gBAAA;AAAyC;;AAIzC;EAAA,4BAA8C;EAA9C,wBAA8C;EAA9C,qBAA8C;EAC9C,aAAqC;EAArC,sBAAqC;EAArC,gBAAA;AAD8C;;AAK9C;EAAA,4BAA2C;EAA3C,qBAA2C;EAA3C,qBAA2C;EAC3C,aAAqC;EAArC,sBAAqC;EAArC,gBAAA;AAD2C;;AAK3C;EAAA,eAAc;EAAd,kBAAA;AAAc;;AACd;EAAA,qBAAA;AAAoC;;AAApC;EAAA,qBAAA;AAAoC;;AAIpC;EAAA,kBAAA;AAAc;;AAId;EAAA,oBAAyG;EAAzG,gDAAyG;EAAzG,kBAAyG;EAAzG,uBAAyG;EAAzG,kBAAyG;EAAzG,sDAAyG;EAAzG,gBAAyG;EAAzG,mBAAyG;EAAzG,oBAAyG;EAAzG,iBAAA;AAAyG;;AAI7G;EAAA,WAAA;AAAoB;;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;;AAIlB;;;;GAIC;;AAED;;;;;;;;GAQC;;AAEC;EADF;MAEI,iCAAiC;MACjC;EAEJ;IADE;;AAGF;IACE,UAAU;IACV,WAAW;EACb;;AAEA;IACE,uBAAuB;EACzB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,WAAW;EACb;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;;IAEE;;AAGA;EAAA,oBAA+C;EAA/C,6CAAA;AAA+C;;AAA/C;EAAA,oBAA+C;EAA/C,gDAAA;AAA+C;;AAI/C;EAAA,oBAA+C;EAA/C,gDAAA;AAA+C;;AAA/C;EAAA,oBAA+C;EAA/C,6CAAA;AAA+C;;AAI/C;EAAA,oBAAuB;EAAvB,gDAAA;AAAuB;;AAIvB;EAAA,oBAAwB;EAAxB,6CAAA;AAAwB;;AAIxB;EAAA,oBAA8C;EAA9C,gDAAA;AAA8C;;AAA9C;EAAA,oBAA8C;EAA9C,gDAAA;AAA8C;;AAOhD;IACE,4CAA4C;EAC9C;;AAGE;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAI3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAI3C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAI3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAG7C;IACE;;;;;;;;;KASC;IACD,gCAAgC;EAClC;;AAiBE;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAO7C;IACE;+CAC2C;IAC3C,oBAAgI;IAAhI,kBAAgI;IAAhI,iCAAgI;EAClI;;AADE;;EAAA;IAAA,iCAAA;EAAgI;AAAA;;AAAhI;EAAA,iCAAA;AAAgI;;AAAhI;;EAAA;IAAA,iCAAA;EAAgI;AAAA;;AAIhI;EAAA,oBAA0D;EAA1D,+CAAA;AAA0D;;AAA1D;EAAA,oBAA0D;EAA1D,+CAAA;AAA0D;;AAI1D;EAAA,oBAA6E;EAA7E,+CAAA;AAA6E;;AAA7E;;EAAA;IAAA,+BAAA;EAA6E;AAAA;;AAA7E;EAAA,oBAA6E;EAA7E,+CAAA;AAA6E;;AAG/E;IACE,oCAAoC;EACtC;;AAEA;;IAEE;;AAEF,8CAA8C;;AAE5C;EAAA,iBAAsG;EAAtG,qBAAsG;EAAtG,wBAAsG;EAAtG,sBAAsG;EAAtG,uBAAsG;EAAtG,mBAAsG;EAAtG,8BAAsG;EACtG,kBAAc;EAAd,mBAAA;AADsG;;AAKtG;EAAA,iBAAsG;EAAtG,qBAAsG;EAAtG,wBAAsG;EAAtG,sBAAsG;EAAtG,uBAAsG;EAAtG,mBAAsG;EAAtG,8BAAsG;EACtG,kBAAc;EAAd,mBAAA;AADsG;;AAKtG;EAAA,iCAA8D;EAA9D,wEAAA;AAA8D;;AAA9D;EAAA,iCAA8D;EAA9D,wEAAA;AAA8D;;AAI9D;EAAA,iBAAsG;EAAtG,qBAAsG;EAAtG,wBAAsG;EAAtG,sBAAsG;EAAtG,uBAAsG;EAAtG,mBAAsG;EAAtG,8BAAA;AAAsG;;AAItG;EAAA,iCAA8D;EAA9D,wEAAA;AAA8D;;AAA9D;EAAA,iCAA8D;EAA9D,wEAAA;AAA8D;;AAGhE;;GAEC;;AAED;IACE;gEAC4D;IAC5D;;uCAEmC;IACnC,4BAA4B;IAC5B;;aAES;EACX;;AAEA;;GAEC;;AACD;IACE,YAAY,EAAE,8BAA8B;IAC5C,YAAY,EAAE,uCAAuC;IACrD;;;;;;KAMC;YAND;;;;;;KAMC;IACD,4BAAoB;YAApB,oBAAoB;IACpB,0BAAkB;YAAlB,kBAAkB;EACpB;;AACA;IACE;MACE,4BAAoB;cAApB,oBAAoB;IACtB;;IAEA;MACE,4BAAoB;cAApB,oBAAoB;IACtB;EACF;;AAEA;IACE,0DAA0D;EAC5D;;AAEA;IACE,YAAY,EAAE,8BAA8B;IAC5C,YAAY,EAAE,uCAAuC;IACrD;;;;;;KAMC;YAND;;;;;;KAMC;IACD,4BAAoB;YAApB,oBAAoB;IACpB,6BAAqB;YAArB,qBAAqB;EACvB;;AACA;IACE;MACE,4BAAoB;cAApB,oBAAoB;IACtB;;IAEA;MACE,4BAAoB;cAApB,oBAAoB;IACtB;EACF;;AAEA;IACE,yDAAyD;EAC3D;;AAEA;IACE;MACE,wBAAwB;IAC1B;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;AAYA;IACE,gBAAgB;IAChB;;;kBAGc;IACd,sBAAsB;EACxB;;AAEA;IACE,gBAAgB;IAChB,+EAA+E;IAC/E,0DAA0D;IAC1D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,gDAAgD;EAClD;;AACA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,2BAA2B;IAC7B;EACF;;AAEA;IACE,0CAA0C;IAC1C,sBAAsB;IACtB,4BAA4B;EAC9B;;AAEA;IACE,2CAA2C;IAC3C,sBAAsB;IACtB,2BAA2B;EAC7B;;AAEA;IACE;MACE,4BAA4B;IAC9B;;IAEA;MACE,2BAA2B;IAC7B;EACF;;AACA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,4BAA4B;IAC9B;EACF;AA/VF;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,6BAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,+BAAmB;EAAnB,uCAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,0CAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,+LAAA;AAAmB;AAAnB;;EAAA;IAAA,yBAAA;EAAmB;AAAA;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB,iBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB,gBAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,iDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,6CAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB,mBAAA;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB,kBAAA;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB,gBAAA;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,mCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,mCAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,mCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,oCAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,oCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,6BAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,oEAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,2DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6DAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6DAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,oEAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB,mBAAA;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB,iBAAA;AAAmB;AAAnB;EAAA,0BAAmB;KAAnB,uBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,6BAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB,kHAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB,uQAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAuGf;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;AA1O/C;;EAsMI;IAAA,oBAA+C;IAA/C,6CAAA;EAA+C;;EAA/C;IAAA,oBAA+C;IAA/C,gDAAA;EAA+C;;EAQ/C;IAAA,oBAAuB;IAAvB,gDAAA;EAAuB;;EAQvB;IAAA,oBAA8C;IAA9C,gDAAA;EAA8C;;EAA9C;IAAA,oBAA8C;IAA9C,gDAAA;EAA8C;;EAY9C;IAAA,kBAA2C;IAA3C,yDAAA;EAA2C;;EAA3C;IAAA,kBAA2C;IAA3C,sDAAA;EAA2C;;EAQ3C;IAAA,kBAA2C;IAA3C,yDAAA;EAA2C;;EAA3C;IAAA,kBAA2C;IAA3C,sDAAA;EAA2C;;EAwC3C;IAAA,oBAA6E;IAA7E,kBAA6E;IAA7E,sBAAA;EAA6E;;EAA7E;IAAA,sBAAA;EAA6E;AAlRjF;AAsNI;EAAA,oBAA8C;EAA9C,gDAAA;AAA8C;AAA9C;EAAA,oBAA8C;EAA9C,gDAAA;AAA8C;AAY9C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;AAT7C;IACE,4CAA4C;EAC9C;AAOE;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;AAhB3C;EAAA,oBAAwB;EAAxB,6CAAA;AAAwB;AA6C1B;IACE;;;;;;;;;KASC;IACD,gCAAgC;EAClC;AA3QF;;EAyZE;IACE,iCAAiC;EAOnC;;IALE;MACE,eAAe;MACf,wBAAwB;MACxB,+BAA+B;IACjC;AAhaJ;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wDAAA;AAAA;AAAA;;EAAA;IAAA,sBAAA;IAAA,uDAAA;EAAA;;EAAA;IAAA,sBAAA;IAAA,sDAAA;EAAA;;EAAA;IAAA,sBAAA;IAAA,wDAAA;EAAA;;EAAA;IAAA,sBAAA;IAAA,uDAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,oEAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,oEAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,yDAAA;EAAA;;EAAA;IAAA,wCAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,yDAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,uDAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,yDAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,wDAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,yDAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,uDAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,cAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,6EAAA;IAAA,iGAAA;IAAA,uGAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,+BAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,iEAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,wDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,oCAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,8DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,6DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,+DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,6DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,0DAAA;AAAA;AAAA;EAAA,sCAAA;AAAA;AAAA;EAAA,6BAAA;EAAA,iEAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,wCAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,yDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,8CAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,+CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,8CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wDAAA;AAAA;AAAA;;EAAA;IAAA,sBAAA;IAAA,yDAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gEAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,sDAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,sDAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,uDAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,sDAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,wDAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,gDAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,+BAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;;EAAA;IAAA,+BAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,sBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,qBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,sBAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,iBAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,gBAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,cAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,2BAAA;IAAA,sBAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iCAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,sBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,eAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,mBAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;;IAAA;MAAA,aAAA;IAAA;;IAAA;MAAA,aAAA;IAAA;;IAAA;MAAA,uBAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,SAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,mBAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,cAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,mBAAA;IAAA,oBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,iBAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,2BAAA;IAAA,+BAAA;IAAA,uCAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,cAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,QAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,kBAAA;AAAA","sourcesContent":["@tailwind base;\n\n/*\nNOTE: Inter font:\n- Defined in HTML template for easy toggling of static() path in trinity & prod (CDN).\n- To save bandwidth, do not include variable italic form.\n- Experimental version with oblique style for italic is too experimental.\n- To save bandwidth, only latin characters are loaded (70KB vs 318KB).\n- Font preload added to HTML template.\n*/\n\n/*\nThese overrides match bootstrap's reset since a lot of styling was developed\nassumings its reset values.\n*/\nsvg {\n  display: inline;\n}\n\na {\n  @apply tw-text-link-blue-light dark:tw-text-link-blue-dark;\n}\n\na:hover {\n  @apply tw-underline;\n}\n\np {\n  @apply tw-mb-4;\n}\n\n/*\nQUICK FIX: Without this, <input> forces fieldset to expand beyond its parent\ncontainer. This, however, doesn't appear to be a common problem (when searching\nfor reasons for this) so it's unclear why 'auto' isn't the default.\n*/\nfieldset {\n  min-inline-size: auto;\n}\n\n/* stylelint-disable custom-property-pattern, function-no-unknown */\n.mdx-editor-container-dark {\n  --accentText: theme('colors.link-blue-dark') !important;\n  --baseBg: #27272a !important; /* Equivalent to bg-highlight */\n  --basePageBg: #202024 !important; /* Equivalent to bg-primary */\n  --baseBgHover: #333 !important;\n  --accentBorder: theme('colors.perpul-dark') !important;\n  --accentSolidHover: theme('colors.perpul-dark') !important;\n  --baseText: theme('colors.slate.200') !important;\n}\n\n.mdx-editor-container-light {\n  --accentBorder: theme('colors.perpul-light') !important;\n  --accentSolidHover: theme('colors.perpul-light') !important;\n  --accentText: theme('colors.link-blue-light') !important;\n  --baseBg: #e1e1e1 !important; /* Equivalent to bg-highlight */\n  --basePageBg: #fefefe !important; /* Equivalent to bg-primary */\n}\n/* stylelint-enable custom-property-pattern, function-no-unknown */\n\n.mdx-editor-content {\n  @apply tw-flex tw-flex-col tw-gap-y-4;\n  @apply tw-text-primary tw-text-sm;\n  @apply tw-p-2.5;\n\n  blockquote {\n    @apply tw-flex tw-flex-col tw-gap-y-4;\n    @apply tw-bg-highlight;\n    @apply tw-ml-[2px];\n    @apply tw-pl-8 tw-pr-2 tw-py-3;\n    @apply tw-border-l-4 tw-rounded-lg tw-border-l-body-light dark:tw-border-l-body-dark;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    @apply tw-mt-4 first:tw-mt-0;\n  }\n\n  h1 {\n    @apply tw-text-[1.3rem] tw-font-bold;\n  }\n\n  h2 {\n    @apply tw-text-[1.25rem] tw-font-bold;\n  }\n\n  h3 {\n    @apply tw-text-[1.2rem] tw-font-bold;\n  }\n\n  h4 {\n    @apply tw-text-[1.15rem] tw-font-bold;\n  }\n\n  h5 {\n    @apply tw-text-[1.10rem] tw-font-semibold;\n  }\n\n  h6 {\n    @apply tw-text-[1.05rem] tw-font-semibold;\n  }\n\n  ol {\n    @apply tw-pl-5 tw-list-decimal tw-list-outside;\n    @apply tw-flex tw-flex-col tw-gap-y-1;\n  }\n\n  ul {\n    @apply tw-pl-5 tw-list-disc tw-list-outside;\n    @apply tw-flex tw-flex-col tw-gap-y-1;\n  }\n\n  li {\n    @apply tw-my-0;\n    @apply [&>ul]:tw-pl-5 [&>ol]:tw-pl-5;\n  }\n\n  p {\n    @apply tw-mb-0;\n  }\n\n  .cm-editor {\n    @apply tw-bg-gray-800 tw-text-light tw-p-3 tw-rounded-md tw-text-sm tw-leading-tight tw-overflow-x-scroll;\n  }\n}\n\n@tailwind components;\n@tailwind utilities;\n\n@layer components {\n  /*\n   * Scrollbar\n   * The primary goal is to customize the horizontal scrollbar for horizontal\n   * feeds as the default is too ugly to bear.\n  */\n\n  /*\n    Firefox only\n\n    Styles are disabled for chrome/webkit because if they're specified they\n    take priority. See:\n\n    https://syntackle.com/blog/changes-to-scrollbar-styling-in-chrome-121/\n\n  */\n  .ff-scrollbar {\n    @supports not selector(::-webkit-scrollbar) {\n      scrollbar-color: #888 transparent;\n      scrollbar-width: thin;\n    }\n  }\n\n  ::-webkit-scrollbar {\n    width: 6px;\n    height: 8px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: #888;\n  }\n\n  .modal-scrollbar::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  .modal-scrollbar::-webkit-scrollbar-thumb {\n    background: #444;\n  }\n\n  .modal-scrollbar::-webkit-scrollbar-thumb:hover {\n    background: #333;\n  }\n\n  .tw-dark ::-webkit-scrollbar-thumb {\n    background: #777;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: #444;\n  }\n\n  .tw-dark ::-webkit-scrollbar-thumb:hover {\n    background: #aaa;\n  }\n\n  /*\n   * Other styles\n   */\n\n  .tw-text-primary {\n    @apply tw-text-[#212529] dark:tw-text-slate-200;\n  }\n\n  .tw-text-primary-inverted {\n    @apply dark:tw-text-[#212529] tw-text-slate-200;\n  }\n\n  .tw-text-light {\n    @apply tw-text-zinc-200;\n  }\n\n  .tw-text-dark {\n    @apply tw-text-[#212529];\n  }\n\n  .tw-text-muted {\n    @apply tw-text-[#696973] dark:tw-text-zinc-400;\n  }\n\n  .tw-bg-custom {\n    background-color: var(--hover-bg) !important;\n  }\n\n  .tw-bg-custom-hover:hover {\n    background-color: var(--hover-bg) !important;\n  }\n\n  .tw-bg-primary {\n    @apply tw-bg-[#fefefe] dark:tw-bg-[#202024];\n  }\n\n  .tw-bg-primary-inverted {\n    @apply tw-bg-[#202024] dark:tw-bg-[#fefefe];\n  }\n\n  .tw-bg-highlight {\n    @apply tw-bg-[#e1e1e1] dark:tw-bg-[#27272a];\n  }\n\n  .tw-bg-highlight-inverted {\n    @apply tw-bg-[#27272a] dark:tw-bg-[#e1e1e1];\n  }\n\n  .tw-bg-striped-light {\n    background-image: linear-gradient(\n      45deg,\n      #f5f5f5 25%,\n      #f0f0f0 25%,\n      #f0f0f0 50%,\n      #f5f5f5 50%,\n      #f5f5f5 75%,\n      #f0f0f0 75%,\n      #f0f0f0 100%\n    );\n    background-size: 56.57px 56.57px;\n  }\n\n  .tw-bg-striped-dark {\n    background-image: linear-gradient(\n      45deg,\n      #2f2f2f 25%,\n      #353535 25%,\n      #353535 50%,\n      #2f2f2f 50%,\n      #2f2f2f 75%,\n      #353535 75%,\n      #353535 100%\n    );\n    background-size: 56.57px 56.57px;\n  }\n\n  .tw-bg-canvas {\n    @apply tw-bg-[#f0f0f0] dark:tw-bg-[#131313];\n  }\n\n  .tw-story-outline {\n    @apply tw-outline tw-outline-2 tw-outline-[#cccccc] dark:tw-outline-[#333333];\n  }\n\n  .tw-story-kbsel-outline {\n    /* Marked !important to take precedence when tw-story-outline is applied\n    due to a simultaneous hover on the story. */\n    @apply tw-outline tw-outline-2 !tw-outline-perpul dark:!tw-outline-perpul hover:!tw-outline-perpul dark:hover:!tw-outline-perpul;\n  }\n\n  .tw-text-blue {\n    @apply tw-text-link-blue-light dark:tw-text-link-blue-dark;\n  }\n\n  .tw-link {\n    @apply tw-text-link-blue-light dark:tw-text-link-blue-dark hover:tw-underline;\n  }\n\n  .tw-youtube-container-portrait {\n    height: max(min(80vh, 700px), 300px);\n  }\n\n  /*\n   * Legacy styling for keyboard highlight bars\n   */\n\n  /* NA = keyboard selection is not applicable */\n  .kb-pad-4-na {\n    @apply tw-border tw-border-solid tw-border-l-[4px] tw-border-l-transparent tw-border-y-0 tw-border-r-0;\n    @apply tw-px-4;\n  }\n\n  .kb-pad-4 {\n    @apply tw-border tw-border-solid tw-border-l-[4px] tw-border-l-transparent tw-border-y-0 tw-border-r-0;\n    @apply tw-px-4;\n  }\n\n  .kb-pad-4.kb-sel {\n    @apply !tw-border-l-perpul-light dark:!tw-border-l-perpul-dark;\n  }\n\n  .kb-bar {\n    @apply tw-border tw-border-solid tw-border-l-[3px] tw-border-l-transparent tw-border-y-0 tw-border-r-0;\n  }\n\n  .kb-bar.kb-sel {\n    @apply !tw-border-l-perpul-light dark:!tw-border-l-perpul-dark;\n  }\n\n  /*\n  * Select styling\n  */\n\n  .tw-select-arrow {\n    background-image: linear-gradient(45deg, transparent 50%, currentcolor 50%),\n      linear-gradient(135deg, currentcolor 50%, transparent 50%);\n    background-position:\n      calc(100% - 20px) calc(1px + 50%),\n      calc(100% - 16px) calc(1px + 50%);\n    background-repeat: no-repeat;\n    background-size:\n      4px 4px,\n      4px 4px;\n  }\n\n  /*\n  * animated linear fade out (for hover menu)\n  */\n  .tw-fade-out-mask-right {\n    padding: 2px; /* creates space for outline */\n    margin: -2px; /* pulls it back to original position */\n    mask-image: linear-gradient(\n      to right,\n      rgba(0 0 0 / 100%) 40%,\n      rgba(0 0 0 / 70%) 55%,\n      rgba(0 0 0 / 40%) 70%,\n      rgba(0 0 0 / 0%) 100%\n    );\n    mask-size: 200% 100%;\n    mask-position: 0 0;\n  }\n  @keyframes tw-fade-out-mask-right-animation {\n    0% {\n      mask-size: 200% 100%;\n    }\n\n    100% {\n      mask-size: 100% 100%;\n    }\n  }\n\n  .tw-apply-mask-right-animate {\n    animation: tw-fade-out-mask-right-animation 0.15s forwards;\n  }\n\n  .tw-fade-out-mask-left {\n    padding: 2px; /* creates space for outline */\n    margin: -2px; /* pulls it back to original position */\n    mask-image: linear-gradient(\n      to left,\n      rgba(0 0 0 / 100%) 40%,\n      rgba(0 0 0 / 70%) 55%,\n      rgba(0 0 0 / 40%) 70%,\n      rgba(0 0 0 / 0%) 100%\n    );\n    mask-size: 200% 100%;\n    mask-position: 100% 0;\n  }\n  @keyframes tw-fade-out-mask-left-animation {\n    0% {\n      mask-size: 200% 100%;\n    }\n\n    100% {\n      mask-size: 100% 100%;\n    }\n  }\n\n  .tw-apply-mask-left-animate {\n    animation: tw-fade-out-mask-left-animation 0.15s forwards;\n  }\n\n  @keyframes pulse-left {\n    0% {\n      transform: translateX(0);\n    }\n\n    50% {\n      transform: translateX(-10px);\n    }\n\n    100% {\n      transform: translateX(0);\n    }\n  }\n\n  .tw-pulse-left {\n    animation: pulse-left 2s infinite;\n\n    &:hover {\n      animation: none;\n      transform: translateX(0);\n      transition: transform 0.5s ease;\n    }\n  }\n\n  .tw-tiktok-text {\n    font-weight: 900;\n    text-shadow:\n      2px 2px 0 #fe2c55,\n      -2px -2px 0 #25f4ee,\n      0 0 5px #000;\n    letter-spacing: 0.05em;\n  }\n\n  .tw-instagram-text {\n    font-weight: 900;\n    background: linear-gradient(45deg, #f58529, #feda77, #dd2a7b, #8134af, #515bd4);\n    /* stylelint-disable-next-line property-no-vendor-prefix */\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    color: transparent;\n    letter-spacing: 0.05em;\n    animation: gradient-move 6s ease-in-out infinite;\n  }\n  @keyframes gradient-move {\n    0% {\n      background-position: 0% 50%;\n    }\n\n    50% {\n      background-position: 100% 50%;\n    }\n\n    100% {\n      background-position: 0% 50%;\n    }\n  }\n\n  .tw-marquee-left {\n    animation: marquee-left 8s linear infinite;\n    will-change: transform;\n    transform: translateX(-125%);\n  }\n\n  .tw-marquee-right {\n    animation: marquee-right 8s linear infinite;\n    will-change: transform;\n    transform: translateX(125%);\n  }\n\n  @keyframes marquee-left {\n    0% {\n      transform: translateX(-125%);\n    }\n\n    100% {\n      transform: translateX(125%);\n    }\n  }\n  @keyframes marquee-right {\n    0% {\n      transform: translateX(125%);\n    }\n\n    100% {\n      transform: translateX(-125%);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
